// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"812":"af346d4c","8589":"716a714c"}[chunkId] + ".chunk.css";
};